/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

// 子组件
import DisplayConfig from '@/views/components/displayConfig'; // 展示配置
import GoodsBlackList from '@/views/components/goodsBlackList/goodsBlackList.vue'; // 商品黑白名单
import BookingTryOnAndExample from '@/views/components/bookingTryOnAndExample/bookingTryOnAndExample.vue'; // 预约试穿及出样
import SiteVirtualManager from '@/views/components/siteVirtualManager/siteVirtualManager.vue'; // 虚拟店长
import SiteStockConfig from '@/views/components/siteStockConfig'; // 库存取值设置
import NoAuth from '@/views/components/noAuth/noAuth.vue';

@Component({
  components: {
    DisplayConfig,
    GoodsBlackList,
    BookingTryOnAndExample,
    SiteVirtualManager,
    SiteStockConfig,
    NoAuth,
  },
})
export default class SiteInfo extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 可提/可售
   * @type {number}
   */
  public stockType = 1;

  /**
   * 之前选择的值
   * @type {number}
   */
  public historyData = 1;

  /**
   * 库存类型列表
   * @type {Array<ItemObject>}
   */
  public stockTypeList = [
    { label: 0, text: '小程序默认库存' },
    { label: 1, text: '可提库存' },
    { label: 2, text: '可售库存' },
  ];

  /**
   * 商品货号
   * @type {string}
   */
  public productCodes = '';

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    // if(this.curPage === "1" && localStorage.getItem('curpage') !== "1"){
    //     IPSService.getSiteStockInfo({
    //         postParams:{
    //             siteId: parseInt(this.$route.params.siteId)
    //         }
    //     }).then((response) =>{
    //         this.stockType = response.stockType;
    //         this.historyData = this.stockType;
    //     });
    // }
    localStorage.setItem('curpage', key);
  }

  /**
   * 切换库存
   * @param {number} val
   * @return null
   */
  public stockTypeChange(val) {
    this.$confirm(`是否将当前网点库存修改为${this.stockTypeList[val].text}`, { type: 'warning' }).then(
      (result) => {
        if (result === 'confirm') {
          this.stockType = val;
          this.historyData = val;
          this.onSave();
        }
      },
      () => {
        this.stockType = this.historyData;
      },
    );
  }

  /**
   * 清除商品缓存
   * @param null
   * @return null
   */
  public clearCache() {
    if (!this.productCodes || !this.productCodes.trim()) {
      this.$message.warning('请输入货号');
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    IPSService.clearProductCodesCache({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
        productCodes: this.productCodes.split(','),
      },
    })
      .then((result) => {
        loading.close();
        this.$message.success('缓存清除成功，请重新进入小程序查看');
      })
      .catch(() => {
        loading.close();
      });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE');
    if (this.isContentBodyShow) {
      // 获取当前页索引
      // this.curPage = Boolean(localStorage.getItem('curpage')) ? localStorage.getItem('curpage') : this.$store.state.authMenuCodeList.indexOf('VSHOP-FUNCTION-SITE-STOCK-CONFIG')>-1 ? '1' : '2';

      // 获取权限下第一个页面
      if (this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-STOCK-CONFIG')) {
        this.curPage = '1';
        IPSService.getSiteStockInfo({
          postParams: {
            siteId: Number.parseInt(this.$route.params.siteId),
          },
        }).then((response) => {
          this.stockType = response.stockType;
          this.historyData = this.stockType;
        });
      } else if (this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-DISPLAY-CONFIG')) {
        this.curPage = '2';
      } else if (this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-HIDDEN-CONFIG')) {
        this.curPage = '3';
      } else if (this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-SITE-APPLY-CONFIG')) {
        this.curPage = '4';
      }
      // else if(this.$store.state.authMenuCodeList.indexOf("VSHOP-FUNCTION-SITE-V-GUIDER-CONFIG") > -1){
      //     this.curPage = "5";
      // };
    }
  }

  /**
   * 判断权限
   */
  public menuAuth(val): boolean {
    return this.$store.state.authMenuCodeList.includes(val);
  }

  /**
   * 保存可提/可售配置
   */
  public onSave() {
    IPSService.saveSiteStock({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
        stockType: this.stockType,
      },
    }).then((response) => {
      if (response.result) {
        this.$message.success('保存成功');
      }
    });
  }
}
